import React, { useContext, useEffect, useState } from "react";
import FormDataContext from "integrations/contexts/FormDataContext";
import useFetch from "integrations/hooks/useFetch";
import urlWithEventHubParams from "enterprise-integrations/helpers/urlWithEventHubParams";
import { ApiRoutes } from "./common/Routes";
import formValidation from "./utils/formValidation";
import { renderOptions } from "../common/Options";
import FormWrap from "../common/FormWrap";
import ValidatedInput from "../common/ValidatedInput";
const StepAuthorize = ({ onSubmit, onChange }) => {
  var _a, _b, _c;
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const { crowdstrikeClientSecret } = formData;
  const region = [
    { label: "US-1 Cloud", value: "https://api.crowdstrike.com" },
    { label: "US-2 Cloud", value: "https://api.us-2.crowdstrike.com" },
    { label: "EU Cloud", value: "https://api.eu-1.crowdstrike.com" },
    { label: "Government Cloud", value: "https://api.laggar.gcw.crowdstrike.com" }
  ];
  const [formValidated, setFormValidated] = useState("");
  const fieldChange = (event) => {
    if (event) {
      setFormValidated(event.target.value);
    }
    onChange(event, null);
  };
  const [CrowdStrikeValidationStatus, setCrowdStrikeValidation] = useFetch(
    null,
    onSubmit,
    "POST",
    {
      crowdstrike_client_id: ((_a = formData == null ? void 0 : formData.crowdstrikeClientId) == null ? void 0 : _a.value) || "",
      crowdstrike_client_secret: ((_b = formData == null ? void 0 : formData.crowdstrikeClientSecret) == null ? void 0 : _b.value) || "",
      crowdstrike_base_url: ((_c = formData == null ? void 0 : formData.crowdstrikeBaseUrl) == null ? void 0 : _c.value) || ""
    },
    urlWithEventHubParams
  );
  useEffect(() => {
    setCrowdStrikeValidation(null);
    if (CrowdStrikeValidationStatus.error) {
      setFormError({
        full_message: CrowdStrikeValidationStatus.error,
        nice_message: "Unable to connect to CrowdStrike using provided configuration."
      });
    }
    return () => {
      setFormError(null);
    };
  }, [CrowdStrikeValidationStatus.error, setCrowdStrikeValidation]);
  const handleSubmit = () => {
    setCrowdStrikeValidation(ApiRoutes.INTEGRATIONS.CrowdStrike.CHECK_CREDENTIALS);
  };
  const isFormValid = formValidation.isFormValid(
    ["crowdstrikeName", "crowdstrikeClientId", "crowdstrikeClientSecret", "crowdstrikeBaseUrl"],
    formData
  );
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: "Verify Connection & Proceed",
      disabled: isFormValid,
      loading: CrowdStrikeValidationStatus.loading,
      title: "",
      error: formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "crowdstrikeName",
        type: "text",
        fieldData: formData.crowdstrikeName,
        onChange,
        placeholder: "Input Name",
        label: "Input Name",
        autoComplete: "off",
        help: "Select a name of your new input that describes it.",
        defaultValue: crowdstrikeClientSecret == null ? void 0 : crowdstrikeClientSecret.value,
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "crowdstrikeClientId",
        type: "text",
        fieldData: formData.crowdstrikeClientId,
        onChange,
        label: "CrowdStrike Client ID",
        help: "The GUID of your application that created the subscription.",
        autoComplete: "off",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "crowdstrikeClientSecret",
        type: "password",
        onChange,
        fieldData: formData.crowdstrikeClientSecret,
        help: "A secret string that the application uses to prove its identity when requesting a token.",
        label: "Client Secret",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        type: "select",
        id: "crowdstrikeBaseUrl",
        onChange: (e) => fieldChange(e),
        fieldData: formData.crowdstrikeBaseUrl,
        help: "CrowdStrike User Account Region.",
        required: true,
        label: "User Region"
      },
      renderOptions(region, "Choose your account region", false)
    ),
    /* @__PURE__ */ React.createElement("p", null, formValidated && `Your Cloud Base Url: ${formValidated}`)
  );
};
export default StepAuthorize;
